import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 18a5.926 5.926 0 1 1 5.913-5.913A5.91 5.91 0 0 1 15 18m0-10a4.05 4.05 0 1 0 4.038 4.05A4.05 4.05 0 0 0 15 8.037z"
      fill="currentColor"
    />
    <path
      d="M23.75 24.1a.924.924 0 0 1-.9-.725A7.04 7.04 0 0 0 16 18h-2a7.04 7.04 0 0 0-6.837 5.375.94.94 0 0 1-1.825-.45 8.91 8.91 0 0 1 8.662-6.8h1.988a8.89 8.89 0 0 1 8.662 6.813.95.95 0 0 1-.687 1.137z"
      fill="currentColor"
    />
    <path
      d="M15 27.887A12.888 12.888 0 1 1 27.888 15 12.9 12.9 0 0 1 15 27.887m0-23.9A11.012 11.012 0 1 0 26.013 15 11.025 11.025 0 0 0 15 3.987"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
